import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'rt-icon',
  templateUrl: './rt-icon.component.html',
  styleUrls: ['./rt-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})


export class RtIconComponent implements OnInit {

  @Input({ required: true }) name: string | 'add-chat' | 'add' | 'add_user' | 'ai' | 'alert' | 'arrow-right' | 'bill' | 'billing' | 'blank-image' | 'calendar' | 'call_hold' | 'call_in' | 'call_out' | 'cash' | 'chat' | 'check-list' | 'check' | 'client_card' | 'close' | 'code-status' | 'contact' | 'copy' | 'create-folder' | 'create-item' | 'creit-card' | 'dark-mode' | 'delete' | 'details' | 'dialplan' | 'dollar' | 'done' | 'double_arrow_right' | 'download' | 'drag_indicator' | 'dropdown-arrow' | 'equipment' | 'error-info' | 'error' | 'europe' | 'excel' | 'execution' | 'eye_hide' | 'file' | 'file_primary' | 'finance' | 'folder-create' | 'folder-open' | 'folder-remove' | 'folder-width-file' | 'folder' | 'group' | 'group_off' | 'icn_check' | 'icn_chevron-down' | 'icn_chevron-left' | 'icn_chevron-right' | 'icn_chevron-up' | 'icn_delete-outline-hover' | 'icn_edit' | 'icn_file-audio-outline-primary' | 'icn_file-audio-outline' | 'icn_file-video-outline-primary' | 'icn_file-video-outline' | 'icn_reload' | 'icn_time-clock' | 'icon_eye-outline' | 'illustration_Upcominglessons_empty' | 'link' | 'list' | 'location' | 'login' | 'logout-ion' | 'logout' | 'magnifier' | 'minus' | 'more' | 'move' | 'navigate' | 'not-schedule' | 'orders-ilustration' | 'orders' | 'pause' | 'pay' | 'pdf' | 'person-circule' | 'person' | 'person_acc' | 'phone_in' | 'phone_out' | 'phone_talk' | 'play' | 'plus' | 'point-of-safe' | 'print' | 'qr' | 'reload' | 'reset-filter' | 'safe-many' | 'service' | 'settings' | 'signin' | 'staple' | 'star' | 'star_fill' | 'stop' | 'sync' | 'telegram' | 'template' | 'time-duration' | 'time' | 'tool' | 'usa' | 'user' | 'verify' | 'volume_down' | 'volume_mute' | 'volume_off' | 'volume_up' | 'warning' | 'warranty_talon';


  /**
   * Size of the icon.:
   * - `sm`: 18px
   * - `md`: 24px
   * - `lg`: 32px
   * - `xl`: 48px
   * - default md
   */
  @Input() size: 'xs' | 'sm' | 'md' | 'lg' | 'xl' = 'md';
  @Input() width = 'auto';
  @Input() height = 'auto';
  @Input() color = 'currentColor';

  sizeTable = {
    xs: '14px',
    sm: '18px',
    md: '24px',
    lg: '32px',
    xl: '48px'
  };

  ngOnInit(): void {
    if (this.height === 'auto' && this.width === 'auto') {
      this.width = this.sizeTable[this.size];
      this.height = this.sizeTable[this.size];
    }
  }
}
